export const getApiErrorMessage = (error, fallback = "Something went wrong.") => {
  if (!error) return fallback;

  const apiMessage =
    error?.response?.data?.message ||
    (typeof error?.response?.data === "string" ? error.response.data : null) ||
    error?.message;

  return apiMessage || fallback;
};

